import { useErrorHandler, useHttpClient } from '@wix/fe-essentials/react';
import { useQuery } from '@wix/fe-essentials/react-query/react';
import { fetchProGalleryIds } from '../api/tpa-apis/pro-gallery/fetch-pro-gallery-ids';
import { fetchProGalleryItems } from '../api/tpa-apis/pro-gallery/fetch-pro-gallery-items';
import { QueryId } from './types';
export const useGalleriesDataQuery = () => {
  const httpClient = useHttpClient();
  const errorHandler = useErrorHandler();
  return useQuery([QueryId.GalleryData], () => {
    return fetchGalleriesData(httpClient, errorHandler);
  }, {
    enabled: false,
    refetchOnWindowFocus: false,
    retry: false
  });
};
const fetchGalleriesData = async (httpClient, errorHandler) => {
  const galleriesDataMap = new Map();
  const galleryIds = await fetchProGalleryIds(httpClient);
  const fetchItemsPromises = galleryIds.map(async galleryId => {
    const items = await fetchProGalleryItems(httpClient, errorHandler, galleryId);
    galleriesDataMap.set(galleryId, items);
  });
  await Promise.all(fetchItemsPromises);
  return galleriesDataMap;
};
//# sourceMappingURL=use-galleries-data-query.js.map